// Action types
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REQUIRES_2FA = 'AUTH_REQUIRES_2FA';
export const AUTH_2FA_START = 'AUTH_2FA_START';

export const PRIVILEGE_UPDATE = 'PRIVILEGE_UPDATE';
